export default __webpack_public_path__ + "static/media/main.1bbebb87.jpg";